(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-announcement"] && !Shopify.designMode) return;
  try {
    class Carousel {
    constructor() {
        this.track = document.getElementById('carouselTrack');
        if (!this.track) return;
        
        this.visibleCount = parseInt(this.track.dataset.visibleCount) || 1;
        this.currentPosition = 0;
        this.currentSlide = 0;
        this.autoplayInterval = null;
        this.isAutoPlaying = this.visibleCount > 1; // Only autoplay if more than 1 slide
        
        this.indicators = document.querySelectorAll('.indicator');
        this.container = document.querySelector('.carousel-container');
        
        this.init();
    }
    
    init() {
        if (this.visibleCount <= 1) {
            // Don't initialize carousel behavior for single slide
            return;
        }
        
        this.indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => {
                this.goToSlide(index);
                this.resetAutoplay();
            });
        });
        
        // Pause autoplay on hover
        this.container.addEventListener('mouseenter', () => {
            this.pauseAutoplay();
        });
        this.container.addEventListener('mouseleave', () => {
            setTimeout(() => this.startAutoplay(), 100);
        });
        
        // Start autoplay
        this.startAutoplay();
    }
    
    updateCarousel(withTransition = true) {
        if (this.visibleCount <= 1) return;
        
        // Toggle transition for seamless reset
        this.track.style.transition = withTransition ? 'transform 0.5s ease-in-out' : 'none';
        
        // Calculate offset based on visible slides
        const slideWidth = 100 / this.visibleCount;
        const offset = -this.currentPosition * slideWidth;
        this.track.style.transform = `translateX(${offset}%)`;
        
        // Update indicators
        this.indicators.forEach((indicator, index) => {
            indicator.classList.toggle('active', index === this.currentSlide);
        });
    }
    
    nextSlide() {
        if (this.visibleCount <= 1) return;
        
        // Move forward
        this.currentPosition++;
        this.currentSlide = (this.currentSlide + 1) % this.visibleCount;
        
        this.updateCarousel(true);
        
        // Reset seamlessly when we reach duplicates
        const totalSlides = this.visibleCount * 2; // Original + duplicates
        if (this.currentPosition >= this.visibleCount + (this.visibleCount > 1 ? 2 : 0)) {
            setTimeout(() => {
                this.currentPosition = this.currentSlide;
                this.updateCarousel(false); // No transition for reset
            }, 500); // Match transition duration
        }
    }
    
    goToSlide(slideIndex) {
        if (slideIndex >= 0 && slideIndex < this.visibleCount) {
            this.currentPosition = slideIndex;
            this.currentSlide = slideIndex;
            this.updateCarousel(true);
        }
    }
    
    startAutoplay() {
        if (!this.isAutoPlaying) return;
        
        this.pauseAutoplay();
        this.autoplayInterval = setInterval(() => {
            this.nextSlide();
        }, 2000);
    }
    
    pauseAutoplay() {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
            this.autoplayInterval = null;
        }
    }
    
    resetAutoplay() {
        this.pauseAutoplay();
        setTimeout(() => {
            if (this.isAutoPlaying) {
                this.startAutoplay();
            }
        }, 300);
    }
}

// Initialize carousel when page loads
document.addEventListener('DOMContentLoaded', () => {
    new Carousel();
});
  } catch(e) { console.error(e); }
})();

})();
